import react from 'react';
import './kirtan.css';

function Kirtan() {
    return (

        <section id="why-choose-1821">
            <div className="cs-container">
                <div className="cs-content">
                    <picture className="cs-picture">
                        <source media="(max-width: 600px)" srcset="/images/kirtan.png"></source>
                        <source media="(min-width: 601px)" srcset="/images/kirtan.png"></source>
                        <img loading="lazy" decoding="async" src="/images/kirtan.png" alt="Krishna Kirtan" ></img>
                    </picture>
                </div>
                <ul className="cs-card-group">
                    <li className="cs-item">
                        <img className="cs-icon" loading="lazy" decoding="async" src="https://csimg.nyc3.cdn.digitaloceanspaces.com/Images/Icons/red-house.svg" alt="icon" width="32" height="32"></img>
                        <div className="cs-item-wrapper">
                            <h3 className="cs-h3">
                                Kirtan Every Sunday
                            </h3>
                            <p className="cs-item-text">
                                Join us for a blissful evening of Kirtan, where we come together to chant the holy names of Krishna, creating a spiritual atmosphere filled with joy and devotion.
                                <span><br></br><br></br></span>
                                <strong>Every Sunday from 6:30 PM to 8:00 PM</strong>
                            </p>
                        </div>
                    </li>
                    <li className="cs-item">
                        <img className="cs-icon" loading="lazy" decoding="async" src="https://csimg.nyc3.cdn.digitaloceanspaces.com/Images/Icons/red-layer.svg" alt="icon" width="32" height="32"></img>
                        <div className="cs-item-wrapper">
                            <h3 className="cs-h3">
                                Your Temple, Your Community
                            </h3>
                            <p className="cs-item-text">
                                Our temple is a place of community and connection, where everyone is welcome to participate in the Kirtan and experience the love and devotion of Krishna consciousness.
                            </p>
                        </div>
                    </li>
                    <li className="cs-item">
                        <img className="cs-icon" loading="lazy" decoding="async" src="https://csimg.nyc3.cdn.digitaloceanspaces.com/Images/Icons/red-hourglass.svg" alt="icon" width="32" height="32"></img>
                        <div className="cs-item-wrapper">
                            <h3 className="cs-h3">
                                Peace and Harmony
                            </h3>
                            <p className="cs-item-text">
                                Experience the peace and harmony that comes from chanting together in a group, as we uplift each other through the power of Kirtan.
                            </p>
                        </div>
                    </li>
                    <li className="cs-item">
                        <img className="cs-icon" loading="lazy" decoding="async" src="https://csimg.nyc3.cdn.digitaloceanspaces.com/Images/Icons/red-flower.svg" alt="icon" width="32" height="32"></img>
                        <div className="cs-item-wrapper">
                            <h3 className="cs-h3">
                                Engery and Enthusiasm
                            </h3>
                            <p className="cs-item-text">
                                The Kirtan is filled with energy and enthusiasm, as we come together to sing and dance in devotion to Krishna, creating a vibrant and uplifting atmosphere.
                            </p>
                        </div>
                    </li>
                </ul>
            </div>
        </section>
                                
    );
}

export default Kirtan;
